import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { ISetScheduleParams } from '../../../spacesPlatform/utils/actionParams';

export class SetRunFlowTasksScheduleRequest extends Request<ISetScheduleParams, IResult> {
  constructor(ids: string[], scheduleId: string) {
    super('setRunFlowTasksSchedule', {
      ids: ids,
      scheduleId: scheduleId,
    });
  }
}
